import React from 'react';

import { Context as ErrorHandlerContext } from 'site-react/core/ErrorHandler';
import { UserConsumer } from 'site-react/data/core/UserContext';

import ShortlistProvider from './ShortlistProvider';

const ShortlistProviderWithContext = (props) => (
  <ErrorHandlerContext.Consumer>
    {({ addError }) => (
      <UserConsumer>
        {({ isLoggedIn, user, updateUser }) => (
          <ShortlistProvider
            {...props}
            addError={addError}
            isLoggedIn={isLoggedIn}
            updateUser={updateUser}
            user={user}
          />
        )}
      </UserConsumer>
    )}
  </ErrorHandlerContext.Consumer>
);

export default ShortlistProviderWithContext;
